<div *ngIf="show==1">
    
    <section class="counselling">
        <div class="container">
            <div class="row two-box ">

                <div class="col-lg-3 col-md-3 col-sm-6  total-count">
                  
                    <div class="row ">
                        <div class="col-md-4 col-lg-4 col-sm-6">
                            <figure class="two">
                                <img src="../../assets/image/2Z9tOd780BNqTgHcjCKqmUoUZYK 1.svg" alt="two-persons"
                                    class="two-persons">
                            </figure>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-6" *ngIf="data">
                            <p class="title-counselling ">TOTAL Counselling</p>
                            <p class="title-number">{{ data.totalCounselling }}</p>

                        </div>
                    </div>
                </div>
                <div class="col-lg-9 col-md-9 col-sm-6   status">
                    <div class="row">
                        <!-- <div *ngFor="let state of data?.stateWiseCounsellingDetails" class="col">
                            <p class="state-name">{{ state.stateName }}</p>
                            <p class="state-number">{{ state.stateWiseTotalCounselling }}</p>
                            <p class="state-percentage">{{ state.stateWisePercentage }}%</p>

                        </div> -->
                        <carousel [cellsToShow]="3" [loop]="true" [autoplay]="false" style="height: 90px;">
                            <div class="carousel-cell col" *ngFor="let state of data?.stateWiseCounsellingDetails">
                                <div class="coun">
                                    <p class="state-name">{{state.stateName}}</p>
                                    <p class="state-number">{{state.stateWiseTotalCounselling}}</p>
                                    <p class="state-percentage">{{state.stateWisePercentage}}%</p>
                                </div>
                            </div>
                        </carousel>
                    </div>

                </div>
            </div>
        </div>
    </section>
    <section class="section_one">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <!-- desktop table view open-->
                    <div class="ibox">
                      
                        <div class="ibox-title report_flexweb">
                           
                            <div>
                                <h5>COUNSELLING REPORT</h5>
                            </div>
                            <div class="icon_flex">
                                <a href="javascript:void(0)" class="dload_rpt" (click)="exportExcel()"> <span><img
                                            src="../../assets/image/vscode-icons_file-type-excel.svg"
                                            alt=""></span>&nbsp;Export in Excel</a>
                            </div>
                        </div>
                        <div class="ibox-content">
                            <div class="table-responsive">
                                <table
                                    class="table table-bordered table-striped dataTables-example cctv_datatable display"
                                    id="example1" #tdata style="width:100%">
                                    <thead>
                                        <tr>
                                            <th>STATE</th>
                                            <th>CITY</th>
                                            <th>CAMPUS</th>
                                            <th style=" width: 57.889px;">TOTAL</th>
                                            <th style=" width: 51.281px;">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let report of data.counsellingReport">
                                            <td>{{ report.stateName }}</td>
                                            <td>{{ report.cityName }}</td>
                                            <td>{{ report.campusName }}</td>
                                            <td style="text-align: right;">{{ report.totalCounselling }}</td>
                                            <td> <img src="../../assets/image/carbon_view.svg" (click)="page(report)" class="pointer"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </section>
</div>
<div *ngIf="show==2">
    <section class="counselling">
        <div class="container">
            <div class="row two-box ">

                <div class="col-lg-3 col-md-3 col-sm-6  total-count">
                    <div class="row ">
                        <div class="col-md-4 col-lg-4 col-sm-6">
                            <figure>
                                <img src="../../assets/image/2Z9tOd780BNqTgHcjCKqmUoUZYK 1.svg" alt="two-persons"
                                    class="two-persons">
                            </figure>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-6" *ngFor="let campus of attendanes?.campuswise" >
                            <p class="title-counselling ">TOTAL Counselling</p>
                            <p class="title-number">{{ campus.campuswiseTotalCounselling}}</p>

                        </div>
                    </div>
                </div>
                <div class="col-lg-9 col-md-9 col-sm-6   status">
                    <div class="row">
                   
                        <div *ngFor="let state of attendanes?.statewise" class="col">
                            <p class="state-name">state</p>
                          <p class="state-number">{{ state.stateName }}</p>
                          <p class="state-percentage">{{ state.statewiseTotalCounselling }}</p>
                         
                        </div>
                      
                     
                        <div *ngFor="let city of attendanes?.citywise" class="col">
                            <p class="state-name">city</p>
                          <p class="state-number">{{ city.cityName }}</p>
                          <p class="state-percentage">{{ city.citywiseTotalCounselling }}</p>
                        
                        </div>
                      
                        
                        <div *ngFor="let campus of attendanes?.campuswise" class="col">
                            <p class="state-name">campus</p>
                          <p class="state-number">{{ campus.campusName }}</p>
                          <p class="state-percentage">{{ campus.campuswiseTotalCounselling }}</p>
                          
                        </div>
                      </div>

                </div>
            </div>
        </div>
    </section>
    <section class="section_one">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <!-- desktop table view open-->
                    <div class="ibox">
                        <div class="ibox-title report_flexweb">
                            <div>
                                <h5>  <span> <button class="image" (click)="backClicked()"><img src="../../assets/image/Vector 629.svg" c></button></span>COUNSELLING REPORT</h5>
                            </div>
                            <div class="icon_flex">
                                <a href="javascript:void(0)" class="dload_rpt" (click)="exportCampuswiseExcel()"> <span><img
                                            src="../../assets/image/vscode-icons_file-type-excel.svg"
                                            alt=""></span>&nbsp;Export in Excel</a>
                            </div>
                        </div>
                        <div class="ibox-content">
                            <div class="table-responsive">
                                <table
                                    class="table table-bordered table-striped dataTables-example cctv_datatable display"
                                    id="example" #tdata style="width:100%">
                                    <thead>
                                        <tr>
                                            <th>ADM_NO</th>
                                            <th>STUDENT_NAME</th>
                                            <th>CLASS</th>
                                            <th>COURSE</th>
                                            <th>PROGRAM</th>
                                            <th>SECTION</th>
                                            <th style="width: 49.8889px !important ;">COUNSEL DATE</th>
                                            <th>COUNSELLOR_NAME</th>
                                            <th style="width: 48.9583px !important;">STATUS</th>
                                            <th>Action</th>
                                            <th>PDF</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let report of attendanes.campuswiseCounsellingReport">
                                            <td>{{ report.admNo }}</td>
                                            <td>{{ report.studentName }}</td>
                                            <td>{{ report.className }}</td>
                                            <td>{{ report.courseTrackName }}</td>
                                            <td>{{ report.examProgramName}}</td>
                                            <td>{{ report.sectionName }}</td>
                                            <td>{{ report.counselDate }}</td>
                                            <td>{{ report.userName}}</td>    
                                            <td >
                                                <ng-container *ngIf="report.totalCounsel=='1'">
                                                    <label class="txt_online">Counselling</label>
                                                </ng-container>
                                                <ng-container *ngIf="report.totalCounsel=='2'">
                                                    <label class="txt_online">1st FollowUp</label>
                                                </ng-container>
                                                <ng-container *ngIf="report.totalCounsel=='3'">
                                                    <label class="txt_online">2nd FollowUp</label>
                                                </ng-container>
                                            </td>                                       
                                            <td> <img src="../../assets/image/carbon_view.svg" (click)="pages(report)"class="pointer"></td>
                                            <td><img src="../../assets/image/pdf.svg" (click)="pdf(report)" class="pointer"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </section>
</div>
<div *ngIf="show == 3" >
    <div >
        <app-counselling-dashboard-view (counseback)="counselling($event)" [id]="reports" ></app-counselling-dashboard-view>
    </div>
</div>





<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>